import { motion } from "framer-motion";
import { HERO } from "@/constants/testIds";
import { useLightbox } from "@/components/site/Lightbox";

export const Hero = () => {
  const { open } = useLightbox();
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const heroImg = "https://customer-assets.emergentagent.com/job_portfolio-site-187/artifacts/rnp54p9s_4531f6a3-ac0f-4723-b1b9-bf839c6de246.jpg";

  return (
    <section
      id="top"
      data-testid={HERO.root}
      className="relative pt-32 pb-20 md:pt-40 md:pb-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-end">
          {/* Left — text */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="md:col-span-7"
          >
            <p className="eyebrow mb-6">Finishing Carpenter — Calgary, AB</p>
            <h1 className="font-serif text-[3.4rem] sm:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-tight">
              The work
              <br />
              <span className="italic font-light text-ink/80">that</span> lives
              <br />
              <span className="text-clay">in the details.</span>
            </h1>
            <p className="mt-10 max-w-md text-ink/70 text-base leading-relaxed">
              I&apos;m Justis Tan — a finishing carpenter based in Calgary,
              working on high-end custom homes for builders like Light House
              and Baywest. Doors, trim, baseboards, casings, and custom built-ins.
            </p>

            <div className="flex flex-wrap gap-4 mt-10">
              <button
                data-testid={HERO.cta}
                onClick={() => scrollTo("#work")}
                className="bg-ink text-bone px-8 py-4 text-[11px] uppercase tracking-[0.22em] hover:bg-clay transition-colors duration-300"
              >
                See the Work
              </button>
              <button
                data-testid={HERO.secondary}
                onClick={() => scrollTo("#contact")}
                className="border border-ink/80 text-ink px-8 py-4 text-[11px] uppercase tracking-[0.22em] hover:bg-ink hover:text-bone transition-colors duration-300"
              >
                Get in Touch
              </button>
            </div>
          </motion.div>

          {/* Right — image */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, ease: "easeOut", delay: 0.2 }}
            className="md:col-span-5 relative"
          >
            <div className="relative overflow-hidden cursor-zoom-in" onClick={() => open(heroImg, "Custom walk-in closet by Justis Tan")}>
              <img
                src={heroImg}
                alt="Custom walk-in closet by Justis Tan"
                className="w-full h-[60vh] md:h-[78vh] object-cover transition-transform duration-[2000ms] hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-bone px-6 py-4 border hairline hidden md:block">
              <p className="eyebrow mb-1">Currently</p>
              <p className="font-serif text-xl">Open to new work</p>
            </div>
          </motion.div>
        </div>

        {/* marquee strip */}
        <div className="mt-24 md:mt-32 border-y hairline py-6 flex flex-wrap items-center justify-between gap-6 text-xs uppercase tracking-[0.22em] text-ink/60">
          <span>Doors</span>
          <span className="hidden sm:inline">·</span>
          <span>Baseboards &amp; Casings</span>
          <span className="hidden sm:inline">·</span>
          <span>Window Trim</span>
          <span className="hidden sm:inline">·</span>
          <span>Custom Built-Ins</span>
          <span className="hidden sm:inline">·</span>
          <span>Blueprint Reading</span>
        </div>
      </div>
    </section>
  );
};
